/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcommerceUserApiTestReq
 */
export interface EcommerceUserApiTestReq {
    /**
     * 平台字典ID。
     * @type {number}
     * @memberof EcommerceUserApiTestReq
     */
    businessPlatformId: number;
    /**
     * 平台侧企业/店铺账号标识。
     * @type {string}
     * @memberof EcommerceUserApiTestReq
     */
    externalAccountId: string;
    /**
     * 待测试Key明文，不落库。
     * @type {string}
     * @memberof EcommerceUserApiTestReq
     */
    credentialKey: string;
    /**
     * 待测试Secret明文，不落库。
     * @type {string}
     * @memberof EcommerceUserApiTestReq
     */
    credentialSecret: string;
}

/**
 * Check if a given object implements the EcommerceUserApiTestReq interface.
 */
export function instanceOfEcommerceUserApiTestReq(value: object): value is EcommerceUserApiTestReq {
    if (!('businessPlatformId' in value) || value['businessPlatformId'] === undefined) return false;
    if (!('externalAccountId' in value) || value['externalAccountId'] === undefined) return false;
    if (!('credentialKey' in value) || value['credentialKey'] === undefined) return false;
    if (!('credentialSecret' in value) || value['credentialSecret'] === undefined) return false;
    return true;
}

export function EcommerceUserApiTestReqFromJSON(json: any): EcommerceUserApiTestReq {
    return EcommerceUserApiTestReqFromJSONTyped(json, false);
}

export function EcommerceUserApiTestReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcommerceUserApiTestReq {
    if (json == null) {
        return json;
    }
    return {
        
        'businessPlatformId': json['businessPlatformId'],
        'externalAccountId': json['externalAccountId'],
        'credentialKey': json['credentialKey'],
        'credentialSecret': json['credentialSecret'],
    };
}

export function EcommerceUserApiTestReqToJSON(json: any): EcommerceUserApiTestReq {
    return EcommerceUserApiTestReqToJSONTyped(json, false);
}

export function EcommerceUserApiTestReqToJSONTyped(value?: EcommerceUserApiTestReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessPlatformId': value['businessPlatformId'],
        'externalAccountId': value['externalAccountId'],
        'credentialKey': value['credentialKey'],
        'credentialSecret': value['credentialSecret'],
    };
}

